import React from 'react'
import AddCalculationEntryForm from './addcalculationentryform'

export default function ViewCalculator() {
  return (
    <div className=''>
        <AddCalculationEntryForm/>
    </div>
  )
}
